import { useCallback, useEffect, useState } from "react";
import useInitState from "../../../../hooks/useInitState";
import useTableSettings from "../../../../hooks/useTableSettings";
import { getAppointments } from "../../../../services/appointmentService";
import moment from "moment";
import { onChangePeriod2UTCFormat, onGetFullname } from "../../../../utils/general";
import { getPatients } from "../../../../services/userService";
import { getAllClientProgramUsers } from "../../../../services/clientProgramService";
import { useBoolean } from "../../../../hooks/useBoolean";
import { onGetDateWithTimezone } from "../../../../utils/formatTime";
import { catalogs } from "../../../../utils/catalogs";
import { Workbook } from 'exceljs';
import FileSaver from 'file-saver'

const useAppointmentsProgramSection = ({
    idclient,
    idclientprogram,
}) => {

    const {
        loading,
        submitting,
        error,
        finish
    } = useInitState()
    const [data, setData] = useState([])
    const downloading = useBoolean()
    const [total, setTotal] = useState(0)
    const [period, setPeriod] = useState({
        start_date:moment().startOf('month').format('YYYY-MM-DD'),
        end_date:moment().endOf('month').format('YYYY-MM-DD')
    })
    const tableSettings = useTableSettings({
        initial_params:{limit:100, offset:0, order:1, order_by:JSON.stringify(['start_date'])}
    })

    const onDownloadData = useCallback(async() => {
        downloading.onTrue()
        const _users = await getPatients(idclient,{offset:0, limit:1500, fields:JSON.stringify([
            'id_user','patient_type_id', 'patient_type',  'patient_segment_type_id',
            'nutritionist_first_name','nutritionist_fathers_last_name','nutritionist_mothers_last_name', 'client'
        ])})
        
        const _userprograms = await getAllClientProgramUsers({
            filter:JSON.stringify({AND:[
                {field:'client_program_id', operator:"=", value:idclientprogram}
            ]})
        })

        let userprogramsdata = []
        let client_name = ""

        for (let i = 0; i < _userprograms.data.length; i++) {
            const element = _userprograms.data[i];
            const userdata = _users.data.find(el => el.id_user === element?.user_id)

            

            client_name = userdata?.client
            const appointment_data = data.filter(el => el?.user_id === element?.user_id)

            //if(appointment_data.length) console.log("Tuvo consulta", appointment_data)

            userprogramsdata.push({
                ...element,
                ...userdata,
                appointments:appointment_data
            })
            
        }

        console.log(userprogramsdata)

        let data2excel = [["Paciente", "Cliente", "Sitio", "Nutriólogo", "Tipo", "No. consulta","Fecha", "Hora", "Estatus", 
             "Motivo de consulta","Grupo de riesgo", "Estatura", "Peso", "IMC", "Masa grasa", "% grasa", "Masa Magra", "Masa músculo","Cintura", "Cadera" , "ICC",  "Diagnóstico",]]
        
        //let data2excel = []
        for (let i = 0; i < userprogramsdata.length; i++) {
            const element = userprogramsdata[i];
            //console.log(element)
            const nutritionist = onGetFullname({
                first_name:element?.nutritionist_first_name,
                fathers_last_name:element?.nutritionist_fathers_last_name,
                mothers_last_name:element?.nutritionist_mothers_last_name,
            })
            const patient = onGetFullname({
                first_name:element?.user_first_name,
                fathers_last_name:element?.user_fathers_last_name,
                mothers_last_name:element?.user_mothers_last_name,
            })

            if(element?.user_first_name === "Vania Elienai"){
                console.log(element)
            }

            let aux = [
               patient, element?.client, element?.user_client_location, nutritionist, element?.patient_type ?? "",
            ]
            if(element.appointments.length > 0){
                for (let j = 0; j < element.appointments.length; j++) {

                    const app = element.appointments[j];
                    const _date = onGetDateWithTimezone(app?.start_date, 'DD MMM YY')
                    const _dateTime = onGetDateWithTimezone(app?.start_date, 'HH:mm')
                    const _status = catalogs.appointment_statuses.find(el => el.value === app?.appointment_status_id)
                    data2excel.push([
                        ...aux,
                        app?.id_appointment, _date,_dateTime, _status?.label, 
                        app?.objective, app?.risk_level, app?.height, app?.weight, app?.imc, app?.fat_mass, app?.percentage_fat, 
                        app?.lean_mass, app?.muscle_mass, app?.circumference_waist, app?.circumference_hips, app?.icc,

                    ])
                }
            }else{
                data2excel.push(aux)
            }
            
        }
        console.log(data2excel)

        

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Pacientes');

        if (!data2excel.length) return;



        // Extraer encabezado
        const headers = data2excel[0];
        const rows = data2excel.slice(1);
        console.log(rows)
      
        // Ordenar filas por el primer valor (asumiendo string)
        rows.sort((a, b) => a[0].localeCompare(b[0]));
      
        // Agregar encabezado
        worksheet.addRow(headers);
      
        // Agregar filas ordenadas
        rows.forEach((row) => {
          worksheet.addRow(row);
        });
        // Generar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, `consultas_${client_name}_${period.start_date}_${period.end_date}.xlsx`);

        

    },[data, idclient, idclientprogram])

    const onUpdatePeriod = useCallback((data) => {
        tableSettings.onUpdatePaginationValue('offset', 0)
        setPeriod(data)
    }, [])

    const onUpdatePagination = useCallback((data) => {
        tableSettings.setPagination(data)
    }, [tableSettings])

    const onGetParams = useCallback(() => {
        let _params = {...tableSettings.pagination}
        _params.offset = _params.offset * _params.limit
        let _periodUTC = onChangePeriod2UTCFormat(period)
        let ANDfilters = [
            {field:'client_id', operator:"=", value:idclient},
            {field:'start_date', operator:">=", value:_periodUTC.start_date},
            {field:'end_date', operator:"<=", value:_periodUTC.end_date},
        ]
        console.log(_params)
        _params.filter = JSON.stringify({AND:ANDfilters})
        return _params

    }, [tableSettings, idclient, period])

    const onRequestAppointments = useCallback(async() => {
        loading.onTrue()
        try {
            const _params = onGetParams()
            console.log("Solicitar appointments")
            console.log(_params)
            const _request = await getAppointments(_params)
            console.log(_request)
            setTotal(_request.count)
            setData(_request.data)
        } catch (error) {
            
        }
        loading.onFalse()
    }, [onGetParams])

    const initialize = useCallback(async() => {
        loading.onTrue()
        try {
            const _params = onGetParams()
            console.log("Solicitar appointments")
            console.log(_params)
            const _request = await getAppointments(_params)
            console.log(_request)
            setTotal(_request.count)
            setData(_request.data)
        } catch (error) {
            console.log(error)
        }
        loading.onFalse()
        finish.onTrue()
    }, [loading])

    useEffect(() => {
        if(finish.value){
            window.scrollTo({top:0, behavior:'smooth'})
            onRequestAppointments()
        }
    }, [tableSettings.pagination, period])

    useEffect(() => {
        initialize()
    }, [idclient, idclientprogram])

    return {
        data, 
        loading,
        total,
        pagination:tableSettings.pagination,
        onUpdatePagination:onUpdatePagination,
        period,
        setPeriod,
        onUpdatePeriod,
        downloading,
        onDownloadData
    };
}
 
export default useAppointmentsProgramSection;